var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eyesK",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.22,275.96c1.93,29.75-17.99,54.7-42.31,64.5-10.24,4.13-21.36,6.07-31.89,3.73-16.09-3.59-30.18-11.19-40.48-25.28-6.83-9.34-12.23-19.24-13.84-30.3-1.65-11.32-1.02-23.03,3.01-34.17,7.94-21.93,23.37-37.25,45.29-43.1,22.1-5.9,43.46-2.13,60.55,15.79,10.48,10.99,16.54,23.91,19.56,38.44.76,3.67.11,7.64.11,10.4h0ZM281.19,262.56c-.04,5.02,4.01,8.15,7.29,5.84,7.65-5.39,14.88-11.42,21.91-17.61.8-.71-.16-5.43-1.3-5.91-2.47-1.04-6.44-1.74-8.28-.43-6.54,4.64-12.48,10.12-18.52,15.43-.85.75-.96,2.33-1.1,2.68h0ZM284.3,241.08c0-5.68-4.62-11.06-9.46-11.03-6.48.04-11.58,5.17-11.54,11.6.04,5.54,5.36,10.97,10.65,10.88,5.42-.09,10.35-5.55,10.35-11.44h0Z",
    className: "main-eye-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497.18,209.59c16.92-1.17,30.91,5.69,42.12,17.38,10.84,11.3,18.41,24.75,19.5,41.07.94,14.02-.41,27.55-7.01,40.2-8.88,17-22.52,28.65-40.87,33.82-7.68,2.17-16.34,3.27-24.13,2.09-10.78-1.64-21.02-5.66-30.15-12.7-9.62-7.41-16.37-16.65-20.92-27.41-2.99-7.07-5.77-15.03-5.51-22.48.36-10.29,1.79-20.72,6.19-30.65,7.79-17.59,19.99-30.42,37.75-37.39,7.17-2.82,15.16-3.56,22.77-5.25.09.44.17.88.26,1.32h0ZM504.07,249.26c-3.45-6.6-8.75-7.39-11.98-5.22-6.85,4.6-12.8,10.64-18.74,16.47-1.05,1.03-1.08,5.09-.17,5.73,1.99,1.4,4.98,2.21,7.4,1.91,2.2-.27,4.39-2.08,6.22-3.64,5.92-5.04,11.66-10.28,17.26-15.25h.01ZM455.28,240.92c-1.1,8.19,4.88,10.81,10.4,11.48,5.42.66,10.7-5.46,10.63-11.33-.07-5.62-5.38-11.18-10.54-11.04-5.42.14-10.48,5.4-10.49,10.9h0Z",
    className: "main-eye-color"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.19,262.56c.13-.35.25-1.93,1.1-2.68,6.04-5.31,11.98-10.79,18.52-15.43,1.84-1.3,5.82-.61,8.28.43,1.15.48,2.11,5.21,1.3,5.91-7.03,6.19-14.26,12.22-21.91,17.61-3.28,2.31-7.33-.83-7.29-5.84h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.3,241.08c0,5.89-4.93,11.35-10.35,11.44-5.3.09-10.62-5.34-10.65-10.88-.04-6.43,5.06-11.56,11.54-11.6,4.85-.03,9.46,5.35,9.46,11.03h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.07,249.26c-5.6,4.97-11.35,10.21-17.26,15.25-1.83,1.56-4.02,3.37-6.22,3.64-2.42.3-5.41-.51-7.4-1.91-.91-.64-.88-4.7.17-5.73,5.94-5.83,11.88-11.86,18.74-16.47,3.23-2.17,8.53-1.38,11.98,5.22h-.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,240.92c0-5.5,5.07-10.75,10.49-10.9,5.16-.14,10.47,5.43,10.54,11.04.07,5.87-5.21,11.99-10.63,11.33-5.52-.67-11.5-3.29-10.4-11.48h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesK);
export default __webpack_public_path__ + "static/media/eyesK.1557d2b78b651efe5cebb4d6fc8846d0.svg";
export { ForwardRef as ReactComponent };